var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.3@core-js/library/modules/_core.js
// module id = 6
// module chunks = 14